/**
 * These are the events that should be handled and sendable by all machines.
 */
const baseEvents = {
  NEXT: () => ({}),
  PREV: () => ({}),
};

export default baseEvents;
